import { render, staticRenderFns } from "./HookLiveStatusIcon.vue?vue&type=template&id=4be5960c&scoped=true"
import script from "./HookLiveStatusIcon.vue?vue&type=script&lang=js"
export * from "./HookLiveStatusIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be5960c",
  null
  
)

export default component.exports